/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_TitleInputs */

const vi_sidebar_layout_title = /** @type {(inputs: Sidebar_Layout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp menu sidebar`)
};

/**

* @param {Sidebar_Layout_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_title = /** @type {((inputs?: Sidebar_Layout_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_title(inputs)
});